/**
 * Restoration slider.
 *
 * The track is a scroll-snap row, so movement already works without this file.
 * Here the arrows, the dots and optional auto-advance are wired on top, and the
 * current slide is read back from the scroll position rather than tracked
 * separately — a swipe and an arrow press then agree with each other.
 */
function initRestorationSlider(viewport) {
  const track = viewport.querySelector('[data-slider-track]');
  const slides = Array.from(viewport.querySelectorAll('[data-slider-slide]'));
  const prevBtn = viewport.querySelector('[data-slider-prev]');
  const nextBtn = viewport.querySelector('[data-slider-next]');
  const dotsContainer = viewport.parentElement.querySelector('[data-slider-dots]');

  if (!track || slides.length === 0) return;

  const single = slides.length < 2;
  if (prevBtn) prevBtn.hidden = single;
  if (nextBtn) nextBtn.hidden = single;
  if (dotsContainer) dotsContainer.hidden = single;
  if (single) return;

  let dots = [];

  function currentIndex() {
    const index = Math.round(track.scrollLeft / track.clientWidth);
    return Math.min(Math.max(index, 0), slides.length - 1);
  }

  function goTo(index) {
    const clamped = Math.min(Math.max(index, 0), slides.length - 1);
    track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
  }

  function syncControls() {
    const index = currentIndex();

    if (prevBtn) prevBtn.disabled = index === 0;
    if (nextBtn) nextBtn.disabled = index === slides.length - 1;

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    dots = slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'restoration-slider__dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => goTo(i));
      dotsContainer.appendChild(dot);
      return dot;
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));

  let scrollTimer;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(syncControls, 80);
  });

  window.addEventListener('resize', syncControls);

  // Auto-advance, paused while the pointer or keyboard focus is on the slider.
  if (viewport.dataset.autoplay === 'true') {
    const speed = (parseInt(viewport.dataset.autoplaySpeed, 10) || 6) * 1000;
    let timer = null;

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (timer) return;
      timer = setInterval(() => {
        const next = currentIndex() + 1;
        goTo(next >= slides.length ? 0 : next);
      }, speed);
    };

    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);
    viewport.addEventListener('focusin', stop);
    viewport.addEventListener('focusout', start);
    start();
  }

  syncControls();
}

function initAllRestorationSliders(scope) {
  const root = scope || document;
  root.querySelectorAll('[data-restoration-slider]').forEach(initRestorationSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllRestorationSliders());
} else {
  initAllRestorationSliders();
}

// Theme editor: re-init when the section is re-rendered.
document.addEventListener('shopify:section:load', (event) => {
  initAllRestorationSliders(event.target);
});
